/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type UpdatePatientInput = {
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
  gender?: Gender | null;
  sleepTestType?: SleepTestType | null;
  startTherapyGroup?: StartTherapyGroup | null;
  userEnteredAhi?: number | null;
  phoneNumber?: string | null;
  phoneExtension?: string | null;
  pushToken?: string | null;
  achievementsPushEnabled?: boolean | null;
  coachingPushEnabled?: boolean | null;
  coachingSmsEnabled?: boolean | null;
  coachingEmailEnabled?: boolean | null;
  cleaningPushEnabled?: boolean | null;
  cleaningSmsEnabled?: boolean | null;
  cleaningEmailEnabled?: boolean | null;
  smartCoachingEnabled?: boolean | null;
  stepCountSharingEnabled?: boolean | null;
  healthSharingEnabled?: boolean | null;
  healthSharingLastPromptedVersion?: string | null;
  shareDetailsWithProviderOptIn?: boolean | null;
  analyticsMode?: AnalyticsMode | null;
  timezoneId?: string | null;
  furiganaFamilyName?: string | null;
  furiganaGivenName?: string | null;
  marketingOptIn?: boolean | null;
  processHealthDataOptIn?: boolean | null;
  heightInCentimeters?: number | null;
  heightInCm?: number | null;
  weightInKilograms?: number | null;
  weightInKg?: number | null;
  streaksEnabled?: boolean | null;
  streaksPushEnabled?: boolean | null;
  announcementsPushEnabled?: boolean | null;
  equipmentReplacementPushEnabled?: boolean | null;
  equipmentResupplyPushEnabled?: boolean | null;
};

export enum Gender {
  preferNotToSay = 'preferNotToSay',
  female = 'female',
  male = 'male',
}

export enum SleepTestType {
  notKnown = 'notKnown',
  home = 'home',
  lab = 'lab',
  both = 'both',
}

export enum StartTherapyGroup {
  justStarting = 'justStarting',
  threeToTwelveMonthsAgo = 'threeToTwelveMonthsAgo',
  moreThanOneYearAgo = 'moreThanOneYearAgo',
  moreThanFiveYearsAgo = 'moreThanFiveYearsAgo',
  notKnown = 'notKnown',
}

export enum AnalyticsMode {
  identified = 'identified',
  anonymous = 'anonymous',
  untracked = 'untracked',
}

export type Patient = {
  __typename: 'Patient';
  id: string;
  email: string;
  countryId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: Gender;
  sleepTestType?: SleepTestType | null;
  startTherapyGroup?: StartTherapyGroup | null;
  userEnteredAhi?: number | null;
  phoneNumber?: string | null;
  aboutMeProgress?: number | null;
  myEquipmentProgress?: number | null;
  myHealthProgress?: number | null;
  overallProgress?: number | null;
  achievementsPushEnabled?: boolean | null;
  coachingPushEnabled?: boolean | null;
  coachingSmsEnabled?: boolean | null;
  coachingEmailEnabled?: boolean | null;
  cleaningPushEnabled?: boolean | null;
  cleaningSmsEnabled?: boolean | null;
  cleaningEmailEnabled?: boolean | null;
  smartCoachingEnabled?: boolean | null;
  stepCountSharingEnabled?: boolean | null;
  healthSharingEnabled?: boolean | null;
  healthSharingLastPromptedVersion?: string | null;
  shareDetailsWithProviderOptIn?: boolean | null;
  analyticsMode?: AnalyticsMode | null;
  analyticsId?: string | null;
  pushToken?: string | null;
  timezoneId?: string | null;
  furiganaFamilyName?: string | null;
  furiganaGivenName?: string | null;
  marketingOptIn?: boolean | null;
  achievements: Array<Achievement>;
  journeys: Array<PatientJourney>;
  firstTherapySessionDate?: string | null;
  lifetimeUsageHours?: number | null;
  processHealthDataOptIn?: boolean | null;
  streaksEnabled?: boolean | null;
  streaksPushEnabled?: boolean | null;
  announcementsPushEnabled?: boolean | null;
  accountCreationTime?: string | null;
  equipmentReplacementPushEnabled?: boolean | null;
  equipmentResupplyPushEnabled?: boolean | null;
  equipmentManagementEnabled?: boolean | null;
  heightInCentimeters?: number | null;
  heightInCm?: number | null;
  weightInKilograms?: number | null;
  weightInKg?: number | null;
  goalTrackingCompleted?: boolean | null;
};

export type Achievement = {
  __typename: 'Achievement';
  id: string;
  name: string;
  description?: string | null;
  imageUrl?: string | null;
  earnedDate?: string | null;
};

export enum PatientJourney {
  preTherapyDiagnostic = 'preTherapyDiagnostic',
  therapyPAP = 'therapyPAP',
  therapyRC = 'therapyRC',
}

export type AddFgDeviceInput = {
  serialNumber: string;
  deviceNumber: string;
  deviceType: FgDeviceType;
};

export enum FgDeviceType {
  AS10 = 'AS10',
  AS11 = 'AS11',
}

export type FgDevice = {
  __typename: 'FgDevice';
  serialNumber: string;
  deviceType?: FgDeviceType | null;
  deviceSeries?: FgSeries | null;
  deviceFamily?: FgFamily | null;
  lastSleepDataReportTime?: string | null;
  localizedName: string;
  imagePath: string;
  imageUrl: string;
  fgDeviceManufacturerName: string;
  fgDevicePatientId: string;
  deviceSubtype: FgDeviceSubtype;
  manufacturer: FgDeviceManufacturer;
  ptcsInfo?: PTCSInfo | null;
};

export enum FgSeries {
  air10 = 'air10',
  air11 = 'air11',
}

export enum FgFamily {
  airCurve = 'airCurve',
  airSense = 'airSense',
}

export enum FgDeviceSubtype {
  PAP = 'PAP',
  RC = 'RC',
}

export enum FgDeviceManufacturer {
  resmed = 'resmed',
}

export type PTCSInfo = {
  __typename: 'PTCSInfo';
  isEnabled: boolean;
  firstEnabledDate?: string | null;
  recommendation: DeviceSettings;
  revertSettings?: DeviceSettings | null;
};

export type DeviceSettings = {
  __typename: 'DeviceSettings';
  autoSetComfort?: string | null;
  rampEnable?: string | null;
  rampTime?: number | null;
  eprEnable?: string | null;
  eprType?: string | null;
  eprPressure?: number | null;
};

export type AddFlowGeneratorInput = {
  serialNumber: string;
  deviceNumber?: string | null;
  isBtConnected?: boolean | null;
  deviceType: FgDeviceType;
};

export type AddFlowGeneratorInputV2 = {
  serialNumber: string;
  deviceNumber?: string | null;
  isBtConnected?: boolean | null;
};

export type UpdateFlowGeneratorInput = {
  serialNumber: string;
  componentUpdates: Array<UpdateFgComponentInput>;
};

export type UpdateFgComponentInput = {
  componentType: FgComponentType;
  replacedDate?: string | null;
  recurrenceDays?: number | null;
};

export enum FgComponentType {
  humidifierTub = 'humidifierTub',
  filter = 'filter',
  tube = 'tube',
}

export type AddMaskInput = {
  maskManufacturerName: string;
  maskCode: string;
};

export type Mask = {
  __typename: 'Mask';
  maskManufacturerName: string;
  maskCode: string;
  maskType: string;
  localizedName: string;
  imagePath: string;
  imageUrl: string;
  maskPatientId: string;
  cushionType: CushionType;
  manufacturer: MaskManufacturer;
  cushionMaterial: CushionMaterial;
};

export enum CushionType {
  fullFace = 'fullFace',
  nasal = 'nasal',
  nasalPillows = 'nasalPillows',
  oral = 'oral',
}

export enum MaskManufacturer {
  resmed = 'resmed',
  loewenstein = 'loewenstein',
  philipsRespironics = 'philipsRespironics',
  fisherPaykel = 'fisherPaykel',
  bmc = 'bmc',
  reactHealth = 'reactHealth',
  sefam = 'sefam',
  airLiquideHealthcare = 'airLiquideHealthcare',
  other = 'other',
}

export enum CushionMaterial {
  fabric = 'fabric',
  memoryFoam = 'memoryFoam',
  silicone = 'silicone',
  unspecified = 'unspecified',
}

export type UpdateMaskInput = {
  maskManufacturerName: string;
  maskCode: string;
  componentUpdates: Array<UpdateMaskComponentInput>;
};

export type UpdateMaskComponentInput = {
  componentType: MaskComponentType;
  replacedDate?: string | null;
  recurrenceDays?: number | null;
};

export enum MaskComponentType {
  cushion = 'cushion',
  frame = 'frame',
  headgear = 'headgear',
}

export type RemoveFgDeviceInput = {
  serialNumber: string;
};

export type RemoveMaskInput = {
  maskManufacturerName: string;
  maskCode: string;
};

export type ClearNotificationInput = {
  id: string;
  action: NotificationAction;
  confirmed: boolean;
  response?: string | null;
  requestor?: string | null;
};

export enum NotificationAction {
  survey = 'survey',
  virtualCoach = 'virtualCoach',
  achievementEarned = 'achievementEarned',
  preTherapyWelcome = 'preTherapyWelcome',
  narrativeScreens = 'narrativeScreens',
  streaks = 'streaks',
  equipmentManagementWelcome = 'equipmentManagementWelcome',
  sleepTestRecordingFailure = 'sleepTestRecordingFailure',
}

export type Notification = {
  __typename: 'Notification';
  id: string;
  action: NotificationAction;
  title: string;
  description?: string | null;
  positiveButtonTitle: string;
  negativeButtonTitle: string;
  url?: string | null;
  imageUrl?: string | null;
  negativeActionId?: string | null;
  negativeActionContent?: NotificationPostActionContent | null;
  achievement?: Achievement | null;
};

export type NotificationPostActionContent = {
  __typename: 'NotificationPostActionContent';
  title?: string | null;
  description: string;
  positiveButtonTitle: string;
  negativeButtonTitle?: string | null;
};

export type CCIDataInput = {
  id: string;
  confirmed: boolean;
  response?: string | null;
  requestor?: string | null;
};

export type HealthMetricDataInput = {
  data: Array<HealthMetricInput>;
};

export type HealthMetricInput = {
  date: string;
  metricValue: number;
  metricType: HealthMetricTypes;
};

export enum HealthMetricTypes {
  stepCount = 'stepCount',
  activeCaloriesBurned = 'activeCaloriesBurned',
  weightKilograms = 'weightKilograms',
  bloodOxygenPercent = 'bloodOxygenPercent',
  bodyMassIndex = 'bodyMassIndex',
  heartRateVariabilityMilliseconds = 'heartRateVariabilityMilliseconds',
  restingHeartRate = 'restingHeartRate',
  timeInBedMinutes = 'timeInBedMinutes',
  totalTimeAsleepMinutes = 'totalTimeAsleepMinutes',
  exerciseMinutes = 'exerciseMinutes',
}

export type HealthMetricData = {
  __typename: 'HealthMetricData';
  date: string;
  metricValue: number;
  metricType: HealthMetricTypes;
};

export type HealthMetricDataInputV2 = {
  data: Array<HealthMetricInputV2>;
};

export type HealthMetricInputV2 = {
  date: string;
  metricValue: number;
  metricType: HealthMetricTypesV2;
};

export enum HealthMetricTypesV2 {
  stepCount = 'stepCount',
  activeCaloriesBurned = 'activeCaloriesBurned',
  weightKilograms = 'weightKilograms',
  bloodOxygenPercent = 'bloodOxygenPercent',
  bodyMassIndex = 'bodyMassIndex',
  heartRateVariabilityMilliseconds = 'heartRateVariabilityMilliseconds',
  restingHeartRate = 'restingHeartRate',
  exerciseMinutes = 'exerciseMinutes',
}

export type HealthMetricDataV2 = {
  __typename: 'HealthMetricDataV2';
  date: string;
  metricValue: number;
  metricType: HealthMetricTypesV2;
};

export type HealthMetricSampleInput = {
  sleepSamples?: Array<SleepMetricSampleInput | null> | null;
};

export type SleepMetricSampleInput = {
  startTime: string;
  endTime: string;
  sampleId: string;
  stage: SleepStage;
  shouldCountAsInBed: boolean;
  recordedManually?: boolean | null;
  source?: MetricSampleSourceInput | null;
};

export enum SleepStage {
  awake = 'awake',
  asleepLight = 'asleepLight',
  asleepDeep = 'asleepDeep',
  asleepRem = 'asleepRem',
  asleepUnspecified = 'asleepUnspecified',
  unspecified = 'unspecified',
}

export type MetricSampleSourceInput = {
  identifier: string;
  productType?: string | null;
};

export type HealthMetricSampleData = SleepMetricSample;

export type SleepMetricSample = {
  __typename: 'SleepMetricSample';
  startTime: string;
  endTime: string;
  sampleId: string;
  stage: SleepStage;
  shouldCountAsInBed: boolean;
  recordedManually?: boolean | null;
  source?: MetricSampleSource | null;
};

export type HealthMetricSample = {
  __typename: 'HealthMetricSample';
  startTime: string;
  endTime: string;
  sampleId: string;
  source?: MetricSampleSource | null;
};

export type MetricSampleSource = {
  __typename: 'MetricSampleSource';
  identifier: string;
  productType?: string | null;
};

export type DismissCardInput = {
  dismissId: string;
  actionId?: string | null;
};

export type DeleteHealthSamplesInput = {
  sampleIds: Array<string>;
};

export type MaskQuestionsInput = {
  data: Array<MaskQuestionInput>;
};

export type MaskQuestionInput = {
  questionId: string;
  answerId: string;
};

export type AddSleepTestInput = {
  activationCode: string;
};

export type UpdateResupplyInfoInput = {
  resupplyDate?: string | null;
  recurrenceDays?: number | null;
};

export type ResupplyInfo = {
  __typename: 'ResupplyInfo';
  dueDate?: string | null;
  totalDays: number;
  hmeInfo?: HmeInfo | null;
};

export type HmeInfo = {
  __typename: 'HmeInfo';
  id: string;
  name: string;
  phoneNumber?: string | null;
  email?: string | null;
  websiteUrl?: string | null;
  imageUrl?: string | null;
};

export type UpdatePTCSInfoInput = {
  isEnabled: boolean;
  revertSettings?: DeviceSettingsInput | null;
};

export type DeviceSettingsInput = {
  autoSetComfort?: string | null;
  rampEnable?: string | null;
  rampTime?: number | null;
  eprEnable?: string | null;
  eprType?: string | null;
  eprPressure?: number | null;
};

export type BookRapidOrderInput = {
  rapidOrderKey: string;
  rapidReorderVisitKey?: string | null;
  items: Array<BookRapidOrderItemInput>;
  shippingAddress: BookRapidOrderAddressInput;
  isShippingAddressConfirmedByPatient?: boolean | null;
  productLineAnswers?: Array<BookRapidOrderProductLineQuestionAnswerInput> | null;
  isPrimaryInsuranceOnFileCorrect?: boolean | null;
  primaryInsurance?: BookRapidOrderPrimaryInsuranceInput | null;
  isCopayCallRequested?: boolean | null;
  patientPhones?: Array<BookRapidOrderPatientPhoneInput> | null;
  scheduledShippingProgram?: BookRapidOrderScheduledShippingProgramInput | null;
};

export type BookRapidOrderItemInput = {
  itemKey: string;
  qty?: number | null;
  hcpcNonFunctionalReasonAnswers?: Array<BookRapidOrderHcpcNonFunctionalReasonAnswerInput> | null;
};

export type BookRapidOrderHcpcNonFunctionalReasonAnswerInput = {
  hcpcCode?: string | null;
  nonFunctionalReasonAnswer: string;
};

export type BookRapidOrderAddressInput = {
  street1: string;
  street2?: string | null;
  city: string;
  stateKey: string;
  postalCode: string;
};

export type BookRapidOrderProductLineQuestionAnswerInput = {
  productLineQuestionKey: string;
  answer: string;
};

export type BookRapidOrderPrimaryInsuranceInput = {
  name?: string | null;
  memberId?: string | null;
  groupId?: string | null;
  phoneNumber?: string | null;
};

export type BookRapidOrderPatientPhoneInput = {
  key?: string | null;
  phoneNumber: string;
  hasTextConsent?: boolean | null;
};

export type BookRapidOrderScheduledShippingProgramInput = {
  key?: string | null;
  optIn?: boolean | null;
};

export type BookRapidOrderResponse = {
  __typename: 'BookRapidOrderResponse';
  message: string;
};

export type PatientWrapper = {
  __typename: 'PatientWrapper';
  patient: Patient;
  fgDevices: Array<FgDevice>;
  masks: Array<Mask>;
  coachingHistory?: PaginatedCoachingHistory | null;
  sleepLibrary: Array<SleepLibrary>;
  equipmentCareCoachingContent: Array<SleepLibrary>;
  sleepRecords?: PaginatedSleepRecords | null;
  notifications: Array<Notification>;
  dashboard: Dashboard;
  healthTrends: HealthTrends;
  achievements: Array<Achievement>;
  goalTrackingDates?: GoalTrackingDates | null;
  sleepTests: Array<SleepTest>;
  cciTherapyResponse?: CCITherapyResponse | null;
  sleepSummary: SleepSummary;
  consents: Array<Consent>;
  narrativeScreens: Array<NarrativeScreen>;
  ptcsInfo?: PTCSInfo | null;
  streakDetails?: StreakDetails | null;
  resupplyInfo?: ResupplyInfo | null;
  dailyTherapyData: Array<DailyTherapyData>;
  insurance?: InsuranceInfo | null;
  provider?: ProviderInfo | null;
  rapidOrder?: RapidOrder | null;
  orderStatus?: Order | null;
  orderHistory?: Array<Order | null> | null;
  salesDialer?: SalesDialer | null;
  snapPatient?: SnapPatient | null;
};

export type PaginatedCoachingHistory = {
  __typename: 'PaginatedCoachingHistory';
  items: Array<CoachingHistory>;
  lastEvaluatedKey?: string | null;
};

export type CoachingHistory = {
  __typename: 'CoachingHistory';
  date: string;
  sleepLibraryId: string;
  smartCoachingId?: string | null;
};

export type SleepLibrary = {
  __typename: 'SleepLibrary';
  title: string;
  thumbnail: string;
  description: string;
  videoOrHtmlUrl: string;
  contentId: string;
  language: string;
  sleepLibraryId: string;
  section: string;
  type: string;
  sleepLibraryPatientId: string;
  analyticsScreenName: string;
  videoId?: string | null;
};

export type PaginatedSleepRecords = {
  __typename: 'PaginatedSleepRecords';
  items: Array<SleepRecord>;
  lastEvaluatedKey?: string | null;
};

export type SleepRecord = {
  __typename: 'SleepRecord';
  startDate: string;
  totalUsage: number;
  sleepScore: number;
  usageScore: number;
  ahiScore: number;
  maskScore: number;
  leakScore: number;
  ahi?: number | null;
  maskPairCount: number;
  leakPercentile?: number | null;
  sleepRecordPatientId?: string | null;
};

export type Dashboard = {
  __typename: 'Dashboard';
  sectionsV1: Array<SectionV1 | null>;
  sectionsV2: Array<SectionV2 | null>;
  sectionsV3: Array<SectionV3>;
  sectionsV4: Array<SectionV4>;
};

export type SectionV1 = {
  __typename: 'SectionV1';
  sectionType: SectionType;
  cards: Array<CardV1 | null>;
};

export enum SectionType {
  grid = 'grid',
  horizontalFlow = 'horizontalFlow',
  verticalFlow = 'verticalFlow',
}

export type CardV1 = {
  __typename: 'CardV1';
  cardType: CardType;
  header?: string | null;
  subheader?: string | null;
  body?: string | null;
  action?: Action | null;
  mediaAsset?: MediaAsset | null;
  button?: Button | null;
  additionalInfo?: string | null;
};

export enum CardType {
  contentOverGradient = 'contentOverGradient',
  contentOverMedia = 'contentOverMedia',
  goal = 'goal',
  mediaWithContent = 'mediaWithContent',
  score = 'score',
  textWithLeftIcon = 'textWithLeftIcon',
  textWithRightIcon = 'textWithRightIcon',
}

export type Action = {
  __typename: 'Action';
  actionType: ActionType;
  value?: string | null;
  screenName?: ScreenName | null;
  analyticsScreenName?: string | null;
  transition?: Transition | null;
  additionalInfo?: string | null;
};

export enum ActionType {
  classicCoaching = 'classicCoaching',
  dialog = 'dialog',
  dismiss = 'dismiss',
  file = 'file',
  local = 'local',
  remote = 'remote',
  webview = 'webview',
}

export enum ScreenName {
  scoreDetails = 'scoreDetails',
  myAchievements = 'myAchievements',
  goalDetails = 'goalDetails',
  coaching = 'coaching',
}

export enum Transition {
  push = 'push',
  modal = 'modal',
  expand = 'expand',
}

export type MediaAsset = {
  __typename: 'MediaAsset';
  assetType: MediaAssetType;
  sourceType: MediaAssetSourceType;
  content: string;
};

export enum MediaAssetType {
  image = 'image',
  video = 'video',
}

export enum MediaAssetSourceType {
  local = 'local',
  remote = 'remote',
}

export type Button = {
  __typename: 'Button';
  buttonType: ButtonType;
  backgroundHexColor?: string | null;
  icon?: string | null;
  text: string;
  textHexColor?: string | null;
  action: Action;
};

export enum ButtonType {
  round = 'round',
  text = 'text',
}

export type SectionV2 = {
  __typename: 'SectionV2';
  sectionType: SectionTypeV2;
  cards: Array<CardV2 | null>;
};

export enum SectionTypeV2 {
  grid = 'grid',
  horizontalFlow = 'horizontalFlow',
  verticalFlow = 'verticalFlow',
}

export type CardV2 = {
  __typename: 'CardV2';
  cardType: CardTypeV2;
  header?: string | null;
  subheader?: string | null;
  body?: string | null;
  action?: ActionV2 | null;
  mediaAsset?: MediaAssetV2 | null;
  button?: ButtonV2 | null;
  additionalInfo?: string | null;
};

export enum CardTypeV2 {
  contentOverGradient = 'contentOverGradient',
  contentOverMedia = 'contentOverMedia',
  goal = 'goal',
  mediaWithContent = 'mediaWithContent',
  score = 'score',
  textWithLeftIcon = 'textWithLeftIcon',
  textWithRightIcon = 'textWithRightIcon',
}

export type ActionV2 = {
  __typename: 'ActionV2';
  actionType: ActionTypeV2;
  value?: string | null;
  screenName?: ScreenNameV2 | null;
  analyticsScreenName?: string | null;
  transition?: TransitionV2 | null;
  additionalInfo?: string | null;
};

export enum ActionTypeV2 {
  dialog = 'dialog',
  dismiss = 'dismiss',
  file = 'file',
  local = 'local',
  remote = 'remote',
  webview = 'webview',
  brightcoveVideo = 'brightcoveVideo',
}

export enum ScreenNameV2 {
  scoreDetails = 'scoreDetails',
  myAchievements = 'myAchievements',
  goalDetails = 'goalDetails',
  coaching = 'coaching',
  maskMagnetInformation = 'maskMagnetInformation',
  goalCalendar = 'goalCalendar',
  nightowlSetup = 'nightowlSetup',
  therapyDetails = 'therapyDetails',
  preTherapyToTherapy = 'preTherapyToTherapy',
  sleepStages = 'sleepStages',
  nightowlRecordingTips = 'nightowlRecordingTips',
  deviceControl = 'deviceControl',
  deviceControlMyOptions = 'deviceControlMyOptions',
  streakDetails = 'streakDetails',
  dawn = 'dawn',
  equipmentFirstReplacement = 'equipmentFirstReplacement',
}

export enum TransitionV2 {
  push = 'push',
  modal = 'modal',
  expand = 'expand',
  fullScreenModal = 'fullScreenModal',
}

export type MediaAssetV2 = {
  __typename: 'MediaAssetV2';
  assetType: MediaAssetTypeV2;
  sourceType: MediaAssetSourceTypeV2;
  content: string;
};

export enum MediaAssetTypeV2 {
  image = 'image',
  video = 'video',
}

export enum MediaAssetSourceTypeV2 {
  local = 'local',
  remote = 'remote',
}

export type ButtonV2 = {
  __typename: 'ButtonV2';
  buttonType: ButtonTypeV2;
  backgroundHexColor?: string | null;
  icon?: string | null;
  text: string;
  textHexColor?: string | null;
  action: ActionV2;
};

export enum ButtonTypeV2 {
  round = 'round',
  text = 'text',
}

export type SectionV3 = {
  __typename: 'SectionV3';
  sectionType: SectionTypeV2;
  cards: Array<CardV3>;
};

export type CardV3 = {
  __typename: 'CardV3';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  smartCoachingId?: string | null;
};

export type ScoreCard = {
  __typename: 'ScoreCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  smartCoachingId?: string | null;
};

export enum Feature {
  classicCoaching = 'classicCoaching',
  goalTracking = 'goalTracking',
  healthSharingPrompt = 'healthSharingPrompt',
  patientMessaging = 'patientMessaging',
  score = 'score',
  smartCoaching = 'smartCoaching',
  regulatory = 'regulatory',
  sleepTest = 'sleepTest',
  careCheckIn = 'careCheckIn',
  luxe = 'luxe',
  sleepStages = 'sleepStages',
  myAirDirect = 'myAirDirect',
  dataWrapped = 'dataWrapped',
  deviceControl = 'deviceControl',
  streaks = 'streaks',
  equipmentManagement = 'equipmentManagement',
  dawn = 'dawn',
  consent = 'consent',
}

export type GoalCard = {
  __typename: 'GoalCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  hasSleepData: boolean;
  requiredHoursPerNight: number;
  numberOfNightsGoal: number;
  nightsAchieved: number;
  goalPeriodStartDate: string;
  goalPeriodEndDate: string;
  action: ActionV3;
  smartCoachingId?: string | null;
};

export type ActionV3 = {
  __typename: 'ActionV3';
  analyticsId: string;
};

export type DismissAction = {
  __typename: 'DismissAction';
  analyticsId: string;
  dismissId: string;
  alert?: Alert | null;
};

export type Alert = {
  __typename: 'Alert';
  header?: string | null;
  body: string;
};

export type LaunchScreenAction = {
  __typename: 'LaunchScreenAction';
  analyticsId: string;
  screenName: ScreenNameV2;
  transition: TransitionV2;
};

export type LaunchSplashScreenAction = {
  __typename: 'LaunchSplashScreenAction';
  analyticsId: string;
  transition: TransitionV2;
  feature: SplashScreenFeature;
};

export enum SplashScreenFeature {
  myAirDirect = 'myAirDirect',
}

export type WebviewAction = {
  __typename: 'WebviewAction';
  analyticsId: string;
  analyticsScreenName: string;
  url: string;
  transition: TransitionV2;
  title?: string | null;
};

export type BrightcoveVideoAction = {
  __typename: 'BrightcoveVideoAction';
  analyticsId: string;
  analyticsScreenName: string;
  videoId: string;
  transition: TransitionV2;
};

export type SwitchTabAction = {
  __typename: 'SwitchTabAction';
  analyticsId: string;
  tabName: TabName;
};

export enum TabName {
  dashboard = 'dashboard',
  history = 'history',
  coaching = 'coaching',
  profile = 'profile',
  equipment = 'equipment',
}

export type CCIWebviewAction = {
  __typename: 'CCIWebviewAction';
  analyticsId: string;
  analyticsScreenName: string;
  transition: TransitionV2;
  url: string;
  surveyId: string;
  dismissId?: string | null;
};

export type LaunchNarrativeScreensAction = {
  __typename: 'LaunchNarrativeScreensAction';
  analyticsId: string;
  narrativeScreensId: string;
};

export type IconCard = {
  __typename: 'IconCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  header: string;
  body?: string | null;
  icon: ImageAsset;
  action?: ActionV3 | null;
  bottomButtons?: Array<TextButton> | null;
  topRightButton?: IconButton | null;
  smartCoachingId?: string | null;
};

export type ImageAsset = RemoteImageAsset | LocalImageAsset;

export type RemoteImageAsset = {
  __typename: 'RemoteImageAsset';
  url: string;
};

export type RemoteMediaAsset = {
  __typename: 'RemoteMediaAsset';
  url: string;
};

export type LocalImageAsset = {
  __typename: 'LocalImageAsset';
  name: string;
};

export type LocalMediaAsset = {
  __typename: 'LocalMediaAsset';
  name: string;
};

export type TextButton = {
  __typename: 'TextButton';
  action: ActionV3;
  text: string;
  smartCoachingButtonType?: string | null;
};

export type ButtonV3 = {
  __typename: 'ButtonV3';
  action: ActionV3;
  smartCoachingButtonType?: string | null;
};

export type RoundButton = {
  __typename: 'RoundButton';
  action: ActionV3;
  text: string;
  smartCoachingButtonType?: string | null;
};

export type IconButton = {
  __typename: 'IconButton';
  action: ActionV3;
  icon: ImageAsset;
  accessibilityText: string;
  smartCoachingButtonType?: string | null;
};

export type ImageWithContentCard = {
  __typename: 'ImageWithContentCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  header: string;
  subheader?: string | null;
  body?: string | null;
  imageAsset: ImageAsset;
  primaryButton: RoundButton;
  secondaryButton?: TextButton | null;
  smartCoachingId?: string | null;
};

export type TitleCard = {
  __typename: 'TitleCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  title: string;
  subheader?: string | null;
  button: RoundButton;
  body?: string | null;
  smartCoachingId?: string | null;
};

export type ProgressCard = {
  __typename: 'ProgressCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  title: string;
  header: string;
  subheader?: string | null;
  secondarySubheader?: string | null;
  progressBar: ProgressBar;
  body?: string | null;
  icon?: ImageAsset | null;
  smartCoachingId?: string | null;
  action?: ActionV3 | null;
  bottomButtons?: Array<TextButton> | null;
  topRightButton?: IconButton | null;
};

export type ProgressBar = FractionalProgressBar | DiscreteProgressBar;

export type FractionalProgressBar = {
  __typename: 'FractionalProgressBar';
  intervals: Array<string>;
  completed: number;
  backgroundHexColor?: string | null;
  foregroundHexColor?: string | null;
};

export type DiscreteProgressBar = {
  __typename: 'DiscreteProgressBar';
  total: number;
  segments: Array<Segment>;
  defaultHexColor?: string | null;
};

export type Segment = {
  __typename: 'Segment';
  segmentCode: string;
  hexColor?: string | null;
};

export type GradientCard = {
  __typename: 'GradientCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  smartCoachingId?: string | null;
  header: string;
  body: string;
  primaryButton: RoundButton;
  secondaryButton?: TextButton | null;
  topRightButton?: IconButton | null;
};

export type TherapyRCCard = {
  __typename: 'TherapyRCCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  smartCoachingId?: string | null;
  sessionDate?: string | null;
  usage?: number | null;
  leakPercentile?: number | null;
  ahi?: number | null;
  maskOnOffCount?: number | null;
};

export type TherapyCard = {
  __typename: 'TherapyCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  smartCoachingId?: string | null;
  sessionDate?: string | null;
  usage?: number | null;
  leakPercentile?: number | null;
  ahi?: number | null;
  maskOnOffCount?: number | null;
};

export type TherapyPAPCard = {
  __typename: 'TherapyPAPCard';
  analyticsId: string;
  feature: Feature;
  sortPriority: number;
  smartCoachingId?: string | null;
  sessionDate?: string | null;
  usage?: number | null;
  leakPercentile?: number | null;
  ahi?: number | null;
  maskOnOffCount?: number | null;
  usageScore?: number | null;
  leakScore?: number | null;
  ahiScore?: number | null;
  maskScore?: number | null;
  sleepScore?: number | null;
};

export type SectionV4 = {
  __typename: 'SectionV4';
  sectionType: SectionTypeV2;
  cards: Array<CardV3>;
};

export type HealthTrends = {
  __typename: 'HealthTrends';
  usage: HealthTrendItem;
  stepCount?: HealthTrendItem | null;
  weightKilograms?: HealthTrendItem | null;
  activeCaloriesBurned?: HealthTrendItem | null;
  bloodOxygenPercent?: HealthTrendItem | null;
  bodyMassIndex?: HealthTrendItem | null;
  heartRateVariabilityMilliseconds?: HealthTrendItem | null;
  restingHeartRate?: HealthTrendItem | null;
  timeInBedMinutes?: HealthTrendItem | null;
  totalTimeAsleepMinutes?: HealthTrendItem | null;
  exerciseMinutes?: HealthTrendItem | null;
  maskSeal: HealthTrendItem;
  ahi: HealthTrendItem;
  maskOnOffCount: HealthTrendItem;
  sleepScore: HealthTrendItem;
  restorativeSleep?: HealthTrendItem | null;
};

export type HealthTrendItem = {
  __typename: 'HealthTrendItem';
  previousAverage?: number | null;
  currentAverage?: number | null;
  trend?: number | null;
};

export type GoalTrackingDates = {
  __typename: 'GoalTrackingDates';
  goalPeriodStartDate: string;
  goalPeriodEndDate: string;
};

export type SleepTest = {
  __typename: 'SleepTest';
  id: string;
  isActive: boolean;
  minRecordingTimeInSeconds?: number | null;
};

export type CCITherapyResponse = {
  __typename: 'CCITherapyResponse';
  cciSurveys: Array<CCISurvey>;
};

export type CCISurvey = {
  __typename: 'CCISurvey';
  dateTime?: string | null;
  items: Array<CCISurveyContent>;
};

export type CCISurveyContent = {
  __typename: 'CCISurveyContent';
  headerText: string;
  bodyContent: Array<CCITextWithAction>;
};

export type CCITextWithAction = {
  __typename: 'CCITextWithAction';
  localizedText: string;
  actionType: CCIActionType;
  contentArg?: string | null;
};

export enum CCIActionType {
  LocalAction = 'LocalAction',
  CCIWebview = 'CCIWebview',
  NoAction = 'NoAction',
}

export type SleepSummary = {
  __typename: 'SleepSummary';
  date: string;
  totalTimeAsleepMinutes?: number | null;
  totalTimeInBedMinutes?: number | null;
  totalUsageHours?: number | null;
  sleepSessions?: Array<SleepSession> | null;
};

export type SleepSession = {
  __typename: 'SleepSession';
  startTime: string;
  endTime: string;
  timeAsleepSeconds: number;
  durationSeconds: number;
  sleepSamples: Array<SleepMetricSample>;
};

export type Consent = {
  __typename: 'Consent';
  consentType: ConsentType;
  consentStatus: ConsentStatus;
  consentCreationTime?: string | null;
  consentExpirationTime?: string | null;
  consentUrl?: string | null;
};

export enum ConsentType {
  nightowlHipaa = 'nightowlHipaa',
}

export enum ConsentStatus {
  consented = 'consented',
  expired = 'expired',
  notApplicable = 'notApplicable',
  revoked = 'revoked',
  withheld = 'withheld',
}

export type NarrativeScreen = {
  __typename: 'NarrativeScreen';
  analyticsId: string;
  backgroundImage: NarrativeBackgroundImage;
  layout: NarrativeLayout;
  content: NarrativeScreenContent;
  buttons: NarrativeScreenButtons;
  showPagingIndicator: boolean;
};

export type NarrativeBackgroundImage = {
  __typename: 'NarrativeBackgroundImage';
  url: string;
  anchorPoint: NarrativeAnchorPoint;
};

export enum NarrativeAnchorPoint {
  topRight = 'topRight',
  topLeft = 'topLeft',
  bottomRight = 'bottomRight',
  bottomLeft = 'bottomLeft',
}

export enum NarrativeLayout {
  headline = 'headline',
  dataPoint = 'dataPoint',
}

export type NarrativeScreenContent = {
  __typename: 'NarrativeScreenContent';
  title: string;
  subtitle: string;
  callout?: string | null;
  dataPoints: Array<NarrativeDataPoint>;
  supplementalSection?: NarrativeSupplementalSection | null;
};

export type NarrativeDataPoint = {
  __typename: 'NarrativeDataPoint';
  title: string;
  value: string;
  callout?: string | null;
};

export type NarrativeSupplementalSection = {
  __typename: 'NarrativeSupplementalSection';
  title: string;
  subtitle: string;
  image?: string | null;
  action?: NarrativeAction | null;
  actionDestinationId?: string | null;
  actionDestinationUrl?: string | null;
  analyticsId?: string | null;
};

export enum NarrativeAction {
  share = 'share',
  navigateForward = 'navigateForward',
  restartFlow = 'restartFlow',
  dismiss = 'dismiss',
}

export type NarrativeScreenButtons = {
  __typename: 'NarrativeScreenButtons';
  primary: NarrativeButton;
  secondary?: NarrativeButton | null;
  leadingToolbar?: NarrativeButton | null;
};

export type NarrativeButton = {
  __typename: 'NarrativeButton';
  action: NarrativeAction;
  style: NarrativeButtonStyle;
  title?: string | null;
  accessibilityText: string;
  shareTextDescription?: string | null;
  shareTextValue?: string | null;
};

export enum NarrativeButtonStyle {
  text = 'text',
  icon = 'icon',
}

export type StreakDetails = {
  __typename: 'StreakDetails';
  currentStreakLength: number;
  currentStreakStartDate: string;
  currentStreakEndDate: string;
  isFromPreviousMonth: boolean;
  longestStreakLength: number;
  freezeDaysRemaining: number;
  freezeDaysMax: number;
  streakUnqualifiedDays: Array<StreakUnqualifiedDay>;
  lastWeekQualifyingDays: number;
  thisWeekQualifyingDays: number;
  isMilestoneDay?: boolean | null;
};

export type StreakUnqualifiedDay = {
  __typename: 'StreakUnqualifiedDay';
  date: string;
  type: StreakUnqualifiedDayType;
};

export enum StreakUnqualifiedDayType {
  freeze = 'freeze',
  missed = 'missed',
  notQualified = 'notQualified',
}

export type DailyTherapyData = {
  __typename: 'DailyTherapyData';
  date: string;
  ahi?: number | null;
  totalUsageHours?: number | null;
  totalSecondsInApnea?: number | null;
  respiratoryEvents?: Array<RespiratoryEvent> | null;
  therapyStatusEvents?: Array<TherapyStatusEvent> | null;
  timeSeriesData?: TimeSeriesData | null;
};

export type RespiratoryEvent = {
  __typename: 'RespiratoryEvent';
  startDate?: string | null;
  endDate: string;
  durationSeconds?: number | null;
  eventType: RespiratoryEventType;
};

export enum RespiratoryEventType {
  centralApnea = 'centralApnea',
  obstructiveApnea = 'obstructiveApnea',
  apnea = 'apnea',
  hypopnea = 'hypopnea',
  rera = 'rera',
}

export type TherapyStatusEvent = {
  __typename: 'TherapyStatusEvent';
  date: string;
  eventType: TherapyStatusEventType;
};

export enum TherapyStatusEventType {
  maskOn = 'maskOn',
  maskOff = 'maskOff',
  powerOff = 'powerOff',
  therapyStart = 'therapyStart',
  therapyStop = 'therapyStop',
}

export type TimeSeriesData = {
  __typename: 'TimeSeriesData';
  leak: Array<TimeSeriesDataInfo>;
  heartRate: Array<TimeSeriesDataInfo>;
  inspiratoryPressure: Array<TimeSeriesDataInfo>;
  expiratoryPressure: Array<TimeSeriesDataInfo>;
  respiratoryRate: Array<TimeSeriesDataInfo>;
  tidalVolume: Array<TimeSeriesDataInfo>;
  minuteVentilation: Array<TimeSeriesDataInfo>;
  alveolarMinuteVentilation: Array<TimeSeriesDataInfo>;
  expiratoryDuration: Array<TimeSeriesDataInfo>;
  ieRatio: Array<TimeSeriesDataInfo>;
  spO2: Array<TimeSeriesDataInfo>;
  inspiratoryDuration: Array<TimeSeriesDataInfo>;
};

export type TimeSeriesDataInfo = {
  __typename: 'TimeSeriesDataInfo';
  period: string;
  start: string;
  values: Array<number>;
  unit: TimeSeriesUnit;
};

export enum TimeSeriesUnit {
  cmH2O = 'cmH2O',
  litres = 'litres',
  litresPerMinute = 'litresPerMinute',
  litresPerSecond = 'litresPerSecond',
  perMinute = 'perMinute',
  percent = 'percent',
  seconds = 'seconds',
}

export type InsuranceInfo = {
  __typename: 'InsuranceInfo';
  name: string;
  planName: string;
  policyGroupId: string;
  policyHolderFirstName: string;
  policyHolderLastName: string;
};

export type ProviderInfo = {
  __typename: 'ProviderInfo';
  name?: string | null;
  phone?: string | null;
  contactInfo?: string | null;
  addressForReturns?: string | null;
  customerServiceEmail?: string | null;
  website?: string | null;
};

export type RapidOrder = {
  __typename: 'RapidOrder';
  rapidOrderKey?: string | null;
  patientKey?: string | null;
  patientFirstName?: string | null;
  patientLastName?: string | null;
  patientEmailAddress?: string | null;
  patientBillingAddress?: Address | null;
  items?: Array<RapidOrderItem | null> | null;
  productLineQuestions?: Array<ProductLineQuestion | null> | null;
};

export type Address = {
  __typename: 'Address';
  street1?: string | null;
  street2?: string | null;
  city?: string | null;
  state?: State | null;
  postalCode?: string | null;
};

export type State = {
  __typename: 'State';
  key?: string | null;
  name?: string | null;
  code?: string | null;
};

export type RapidOrderItem = {
  __typename: 'RapidOrderItem';
  itemKey?: string | null;
  itemDescription?: string | null;
  qty?: number | null;
  hcpcs?: Array<Hcpc | null> | null;
  eligibilityDrivingHcpcForItem?: string | null;
};

export type Hcpc = {
  __typename: 'Hcpc';
  hcpcCode?: string | null;
  hcpcTypeName?: string | null;
  qty?: number | null;
  nonFunctionalReasonAnswerChoices?: Array<string | null> | null;
  lastDateOfService?: string | null;
  isRequiredBeforeBooking?: boolean | null;
  isRequiredEvenAfterBooking?: boolean | null;
  isRequiredForMedicareOnly?: boolean | null;
};

export type ProductLineQuestion = {
  __typename: 'ProductLineQuestion';
  productLineQuestionKey?: string | null;
  productLineQuestionDataType?: string | null;
  productLineQuestionName?: string | null;
  productLineQuestionText?: string | null;
  sortOrder?: number | null;
  isRequiredBeforeBooking?: boolean | null;
  isRequiredEvenAfterBooking?: boolean | null;
  isRequiredForMedicareOnly?: boolean | null;
  mustBeYesGroupName?: string | null;
  mustBeNoGroupName?: string | null;
  answerChoices?: Array<string | null> | null;
};

export type Order = {
  __typename: 'Order';
  key?: string | null;
  id?: number | null;
  currentStatus?: string | null;
  currentStatusSince?: string | null;
  workflowState?: string | null;
  workflowStateSince?: string | null;
  documentsNeeded?: Array<string | null> | null;
  preshipIssues?: Array<string | null> | null;
  createdDate?: string | null;
  bookedDate?: string | null;
  sentToShipperDate?: string | null;
  shippedDate?: string | null;
  pickedUpDate?: string | null;
  sentToBillingDate?: string | null;
  voidedDate?: string | null;
  writtenOffDate?: string | null;
  completedDate?: string | null;
  items?: Array<StatusItem | null> | null;
  shippingAddress?: Address | null;
  shippingCarrier?: string | null;
  shippingTrackingNumber?: string | null;
  shippingTrackingNumberUrl?: string | null;
};

export type StatusItem = {
  __typename: 'StatusItem';
  itemKey?: string | null;
  itemName?: string | null;
  itemDescription?: string | null;
  qty?: number | null;
};

export type SalesDialer = {
  __typename: 'SalesDialer';
  patientKey: string;
  daysUntilPatientCanReorder: number;
  isEligibleForReorder: boolean;
};

export type SnapPatient = {
  __typename: 'SnapPatient';
  patientKey?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  suffix?: string | null;
  emailAddress?: string | null;
  dateOfBirth?: string | null;
};

export type FeatureMetadata = {
  __typename: 'FeatureMetadata';
  dawn: DawnFeature;
  deviceControl: DeviceControlFeature;
  myAirDirect: MyAirDirectFeature;
  streaks: StreaksFeature;
  equipmentManagement: EquipmentManagementFeature;
  coaching: CoachingFeature;
  support: SupportFeature;
  mask: MaskFeature;
  achievements: AchievementsFeature;
  userInfo: UserInfoFeature;
  appWidget: AppWidgetFeature;
  watch: WatchFeature;
  sleepRecord: SleepRecordFeature;
  consent: ConsentFeature;
  dataExperience: DataExperienceFeature;
  sleepTest: SleepTestFeature;
};

export type DawnFeature = {
  __typename: 'DawnFeature';
  enabled: boolean;
  myTherapyNavigatorEnabled: boolean;
  url?: string | null;
};

export type DeviceControlFeature = {
  __typename: 'DeviceControlFeature';
  enabled: boolean;
  version: number;
};

export type MyAirDirectFeature = {
  __typename: 'MyAirDirectFeature';
  enabled: boolean;
};

export type StreaksFeature = {
  __typename: 'StreaksFeature';
  enabled: boolean;
};

export type EquipmentManagementFeature = {
  __typename: 'EquipmentManagementFeature';
  enabled: boolean;
  scheduleConfig: Array<ScheduleConfigItem>;
  marketType: EquipmentMarketType;
};

export type ScheduleConfigItem =
  | FgEquipmentReplacementScheduleConfigItem
  | MaskEquipmentReplacementScheduleConfigItem
  | ResupplyScheduleConfigItem;

export type FgEquipmentReplacementScheduleConfigItem = {
  __typename: 'FgEquipmentReplacementScheduleConfigItem';
  recommendedRecurrenceDays: number;
  minRecurrenceDays: number;
  maxRecurrenceDays: number;
};

export type ScheduleConfigItemInterface = {
  __typename: 'ScheduleConfigItemInterface';
  recommendedRecurrenceDays: number;
  minRecurrenceDays: number;
  maxRecurrenceDays: number;
};

export type MaskEquipmentReplacementScheduleConfigItem = {
  __typename: 'MaskEquipmentReplacementScheduleConfigItem';
  cushionType?: CushionType | null;
  cushionMaterial?: CushionMaterial | null;
  recommendedRecurrenceDays: number;
  minRecurrenceDays: number;
  maxRecurrenceDays: number;
};

export type ResupplyScheduleConfigItem = {
  __typename: 'ResupplyScheduleConfigItem';
  recommendedRecurrenceDays: number;
  minRecurrenceDays: number;
  maxRecurrenceDays: number;
};

export enum EquipmentMarketType {
  insuranceDriven = 'insuranceDriven',
  primarilyReimbursed = 'primarilyReimbursed',
}

export type CoachingFeature = {
  __typename: 'CoachingFeature';
  smartCoachingEnabled: boolean;
};

export type SupportFeature = {
  __typename: 'SupportFeature';
  showAdaLabel: boolean;
};

export type MaskFeature = {
  __typename: 'MaskFeature';
  showMaskMagneticEducationalMaterials: boolean;
};

export type AchievementsFeature = {
  __typename: 'AchievementsFeature';
  enabled: boolean;
};

export type UserInfoFeature = {
  __typename: 'UserInfoFeature';
  papTherapyOnboardingQuestionsEnabled: boolean;
};

export type AppWidgetFeature = {
  __typename: 'AppWidgetFeature';
  enabled: boolean;
};

export type WatchFeature = {
  __typename: 'WatchFeature';
  enabled: boolean;
};

export type SleepRecordFeature = {
  __typename: 'SleepRecordFeature';
  scoreEnabled: boolean;
};

export type ConsentFeature = {
  __typename: 'ConsentFeature';
  isRevokeConsentVisible: boolean;
  isUpdateConsentVisible: boolean;
  isFaqContentVisible: boolean;
};

export type DataExperienceFeature = {
  __typename: 'DataExperienceFeature';
  timelineEnabled: boolean;
};

export type SleepTestFeature = {
  __typename: 'SleepTestFeature';
  enabled: boolean;
};

export type MaskQuestion = {
  __typename: 'MaskQuestion';
  questionId: string;
  localizedQuestion: string;
  answers: Array<MaskAnswer>;
};

export type MaskAnswer = {
  __typename: 'MaskAnswer';
  answerId: string;
  localizedAnswer: string;
};

export type UpdatePatientMutationVariables = {
  input: UpdatePatientInput;
};

export type UpdatePatientMutation = {
  updatePatient?: {
    __typename: 'Patient';
    id: string;
    email: string;
    countryId: string;
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    gender: Gender;
    sleepTestType?: SleepTestType | null;
    startTherapyGroup?: StartTherapyGroup | null;
    userEnteredAhi?: number | null;
    phoneNumber?: string | null;
    aboutMeProgress?: number | null;
    myEquipmentProgress?: number | null;
    myHealthProgress?: number | null;
    overallProgress?: number | null;
    achievementsPushEnabled?: boolean | null;
    coachingPushEnabled?: boolean | null;
    coachingSmsEnabled?: boolean | null;
    coachingEmailEnabled?: boolean | null;
    cleaningPushEnabled?: boolean | null;
    cleaningSmsEnabled?: boolean | null;
    cleaningEmailEnabled?: boolean | null;
    smartCoachingEnabled?: boolean | null;
    stepCountSharingEnabled?: boolean | null;
    healthSharingEnabled?: boolean | null;
    healthSharingLastPromptedVersion?: string | null;
    shareDetailsWithProviderOptIn?: boolean | null;
    analyticsMode?: AnalyticsMode | null;
    analyticsId?: string | null;
    pushToken?: string | null;
    timezoneId?: string | null;
    furiganaFamilyName?: string | null;
    furiganaGivenName?: string | null;
    marketingOptIn?: boolean | null;
    achievements: Array<{
      __typename: 'Achievement';
      id: string;
      name: string;
      description?: string | null;
      imageUrl?: string | null;
      earnedDate?: string | null;
    }>;
    journeys: Array<PatientJourney>;
    firstTherapySessionDate?: string | null;
    lifetimeUsageHours?: number | null;
    processHealthDataOptIn?: boolean | null;
    streaksEnabled?: boolean | null;
    streaksPushEnabled?: boolean | null;
    announcementsPushEnabled?: boolean | null;
    accountCreationTime?: string | null;
    equipmentReplacementPushEnabled?: boolean | null;
    equipmentResupplyPushEnabled?: boolean | null;
    equipmentManagementEnabled?: boolean | null;
    heightInCentimeters?: number | null;
    heightInCm?: number | null;
    weightInKilograms?: number | null;
    weightInKg?: number | null;
    goalTrackingCompleted?: boolean | null;
  } | null;
};

export type AddFgDeviceMutationVariables = {
  input: AddFgDeviceInput;
};

export type AddFgDeviceMutation = {
  addFgDevice: Array<{
    __typename: 'FgDevice';
    serialNumber: string;
    deviceType?: FgDeviceType | null;
    deviceSeries?: FgSeries | null;
    deviceFamily?: FgFamily | null;
    lastSleepDataReportTime?: string | null;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    fgDeviceManufacturerName: string;
    fgDevicePatientId: string;
    deviceSubtype: FgDeviceSubtype;
    manufacturer: FgDeviceManufacturer;
    ptcsInfo?: {
      __typename: 'PTCSInfo';
      isEnabled: boolean;
      firstEnabledDate?: string | null;
      recommendation: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      };
      revertSettings?: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      } | null;
    } | null;
  }>;
};

export type AddFlowGeneratorMutationVariables = {
  input: AddFlowGeneratorInput;
};

export type AddFlowGeneratorMutation = {
  addFlowGenerator: Array<{
    __typename: 'FgDevice';
    serialNumber: string;
    deviceType?: FgDeviceType | null;
    deviceSeries?: FgSeries | null;
    deviceFamily?: FgFamily | null;
    lastSleepDataReportTime?: string | null;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    fgDeviceManufacturerName: string;
    fgDevicePatientId: string;
    deviceSubtype: FgDeviceSubtype;
    manufacturer: FgDeviceManufacturer;
    ptcsInfo?: {
      __typename: 'PTCSInfo';
      isEnabled: boolean;
      firstEnabledDate?: string | null;
      recommendation: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      };
      revertSettings?: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      } | null;
    } | null;
  }>;
};

export type AddFlowGeneratorV2MutationVariables = {
  input: AddFlowGeneratorInputV2;
};

export type AddFlowGeneratorV2Mutation = {
  addFlowGeneratorV2: Array<{
    __typename: 'FgDevice';
    serialNumber: string;
    deviceType?: FgDeviceType | null;
    deviceSeries?: FgSeries | null;
    deviceFamily?: FgFamily | null;
    lastSleepDataReportTime?: string | null;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    fgDeviceManufacturerName: string;
    fgDevicePatientId: string;
    deviceSubtype: FgDeviceSubtype;
    manufacturer: FgDeviceManufacturer;
    ptcsInfo?: {
      __typename: 'PTCSInfo';
      isEnabled: boolean;
      firstEnabledDate?: string | null;
      recommendation: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      };
      revertSettings?: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      } | null;
    } | null;
  }>;
};

export type UpdateFlowGeneratorMutationVariables = {
  input: UpdateFlowGeneratorInput;
};

export type UpdateFlowGeneratorMutation = {
  updateFlowGenerator: Array<{
    __typename: 'FgDevice';
    serialNumber: string;
    deviceType?: FgDeviceType | null;
    deviceSeries?: FgSeries | null;
    deviceFamily?: FgFamily | null;
    lastSleepDataReportTime?: string | null;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    fgDeviceManufacturerName: string;
    fgDevicePatientId: string;
    deviceSubtype: FgDeviceSubtype;
    manufacturer: FgDeviceManufacturer;
    ptcsInfo?: {
      __typename: 'PTCSInfo';
      isEnabled: boolean;
      firstEnabledDate?: string | null;
      recommendation: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      };
      revertSettings?: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      } | null;
    } | null;
  }>;
};

export type AddMaskMutationVariables = {
  input: AddMaskInput;
};

export type AddMaskMutation = {
  addMask: Array<{
    __typename: 'Mask';
    maskManufacturerName: string;
    maskCode: string;
    maskType: string;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    maskPatientId: string;
    cushionType: CushionType;
    manufacturer: MaskManufacturer;
    cushionMaterial: CushionMaterial;
  }>;
};

export type UpdateMaskMutationVariables = {
  input: UpdateMaskInput;
};

export type UpdateMaskMutation = {
  updateMask: Array<{
    __typename: 'Mask';
    maskManufacturerName: string;
    maskCode: string;
    maskType: string;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    maskPatientId: string;
    cushionType: CushionType;
    manufacturer: MaskManufacturer;
    cushionMaterial: CushionMaterial;
  }>;
};

export type RemoveFgDeviceMutationVariables = {
  input: RemoveFgDeviceInput;
};

export type RemoveFgDeviceMutation = {
  removeFgDevice: Array<{
    __typename: 'FgDevice';
    serialNumber: string;
    deviceType?: FgDeviceType | null;
    deviceSeries?: FgSeries | null;
    deviceFamily?: FgFamily | null;
    lastSleepDataReportTime?: string | null;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    fgDeviceManufacturerName: string;
    fgDevicePatientId: string;
    deviceSubtype: FgDeviceSubtype;
    manufacturer: FgDeviceManufacturer;
    ptcsInfo?: {
      __typename: 'PTCSInfo';
      isEnabled: boolean;
      firstEnabledDate?: string | null;
      recommendation: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      };
      revertSettings?: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      } | null;
    } | null;
  }>;
};

export type RemoveMaskMutationVariables = {
  input: RemoveMaskInput;
};

export type RemoveMaskMutation = {
  removeMask: Array<{
    __typename: 'Mask';
    maskManufacturerName: string;
    maskCode: string;
    maskType: string;
    localizedName: string;
    imagePath: string;
    imageUrl: string;
    maskPatientId: string;
    cushionType: CushionType;
    manufacturer: MaskManufacturer;
    cushionMaterial: CushionMaterial;
  }>;
};

export type ClearNotificationsMutationVariables = {
  input: Array<ClearNotificationInput>;
};

export type ClearNotificationsMutation = {
  clearNotifications: Array<{
    __typename: 'Notification';
    id: string;
    action: NotificationAction;
    title: string;
    description?: string | null;
    positiveButtonTitle: string;
    negativeButtonTitle: string;
    url?: string | null;
    imageUrl?: string | null;
    negativeActionId?: string | null;
    negativeActionContent?: {
      __typename: 'NotificationPostActionContent';
      title?: string | null;
      description: string;
      positiveButtonTitle: string;
      negativeButtonTitle?: string | null;
    } | null;
    achievement?: {
      __typename: 'Achievement';
      id: string;
      name: string;
      description?: string | null;
      imageUrl?: string | null;
      earnedDate?: string | null;
    } | null;
  }>;
};

export type SubmitCCIDataMutationVariables = {
  input?: CCIDataInput | null;
};

export type SubmitCCIDataMutation = {
  submitCCIData: boolean;
};

export type AddHealthMetricMutationVariables = {
  input: HealthMetricDataInput;
};

export type AddHealthMetricMutation = {
  addHealthMetric: Array<{
    __typename: 'HealthMetricData';
    date: string;
    metricValue: number;
    metricType: HealthMetricTypes;
  }>;
};

export type AddHealthMetricV2MutationVariables = {
  input: HealthMetricDataInputV2;
};

export type AddHealthMetricV2Mutation = {
  addHealthMetricV2: Array<{
    __typename: 'HealthMetricDataV2';
    date: string;
    metricValue: number;
    metricType: HealthMetricTypesV2;
  }>;
};

export type AddHealthMetricSamplesMutationVariables = {
  input: HealthMetricSampleInput;
};

export type AddHealthMetricSamplesMutation = {
  addHealthMetricSamples: Array<{
    __typename: 'SleepMetricSample';
    startTime: string;
    endTime: string;
    sampleId: string;
    stage: SleepStage;
    shouldCountAsInBed: boolean;
    recordedManually?: boolean | null;
    source?: {
      __typename: 'MetricSampleSource';
      identifier: string;
      productType?: string | null;
    } | null;
  }>;
};

export type DismissCardMutationVariables = {
  input: DismissCardInput;
};

export type DismissCardMutation = {
  dismissCard?: string | null;
};

export type DeleteHealthSamplesMutationVariables = {
  input: DeleteHealthSamplesInput;
};

export type DeleteHealthSamplesMutation = {
  deleteHealthSamples: Array<string>;
};

export type SubmitMaskAnswersMutationVariables = {
  input: MaskQuestionsInput;
};

export type SubmitMaskAnswersMutation = {
  submitMaskAnswers: boolean;
};

export type AddSleepTestMutationVariables = {
  input: AddSleepTestInput;
};

export type AddSleepTestMutation = {
  addSleepTest?: string | null;
};

export type UpdateResupplyInfoMutationVariables = {
  input: UpdateResupplyInfoInput;
};

export type UpdateResupplyInfoMutation = {
  updateResupplyInfo?: {
    __typename: 'ResupplyInfo';
    dueDate?: string | null;
    totalDays: number;
    hmeInfo?: {
      __typename: 'HmeInfo';
      id: string;
      name: string;
      phoneNumber?: string | null;
      email?: string | null;
      websiteUrl?: string | null;
      imageUrl?: string | null;
    } | null;
  } | null;
};

export type UpdatePTCSInfoMutationVariables = {
  input: UpdatePTCSInfoInput;
};

export type UpdatePTCSInfoMutation = {
  updatePTCSInfo?: {
    __typename: 'PTCSInfo';
    isEnabled: boolean;
    firstEnabledDate?: string | null;
    recommendation: {
      __typename: 'DeviceSettings';
      autoSetComfort?: string | null;
      rampEnable?: string | null;
      rampTime?: number | null;
      eprEnable?: string | null;
      eprType?: string | null;
      eprPressure?: number | null;
    };
    revertSettings?: {
      __typename: 'DeviceSettings';
      autoSetComfort?: string | null;
      rampEnable?: string | null;
      rampTime?: number | null;
      eprEnable?: string | null;
      eprType?: string | null;
      eprPressure?: number | null;
    } | null;
  } | null;
};

export type BookRapidOrderMutationVariables = {
  input: BookRapidOrderInput;
};

export type BookRapidOrderMutation = {
  bookRapidOrder?: {
    __typename: 'BookRapidOrderResponse';
    message: string;
  } | null;
};

export type GetPatientWrapperQuery = {
  getPatientWrapper?: {
    __typename: 'PatientWrapper';
    patient: {
      __typename: 'Patient';
      id: string;
      email: string;
      countryId: string;
      firstName: string;
      lastName: string;
      dateOfBirth: string;
      gender: Gender;
      sleepTestType?: SleepTestType | null;
      startTherapyGroup?: StartTherapyGroup | null;
      userEnteredAhi?: number | null;
      phoneNumber?: string | null;
      aboutMeProgress?: number | null;
      myEquipmentProgress?: number | null;
      myHealthProgress?: number | null;
      overallProgress?: number | null;
      achievementsPushEnabled?: boolean | null;
      coachingPushEnabled?: boolean | null;
      coachingSmsEnabled?: boolean | null;
      coachingEmailEnabled?: boolean | null;
      cleaningPushEnabled?: boolean | null;
      cleaningSmsEnabled?: boolean | null;
      cleaningEmailEnabled?: boolean | null;
      smartCoachingEnabled?: boolean | null;
      stepCountSharingEnabled?: boolean | null;
      healthSharingEnabled?: boolean | null;
      healthSharingLastPromptedVersion?: string | null;
      shareDetailsWithProviderOptIn?: boolean | null;
      analyticsMode?: AnalyticsMode | null;
      analyticsId?: string | null;
      pushToken?: string | null;
      timezoneId?: string | null;
      furiganaFamilyName?: string | null;
      furiganaGivenName?: string | null;
      marketingOptIn?: boolean | null;
      achievements: Array<{
        __typename: 'Achievement';
        id: string;
        name: string;
        description?: string | null;
        imageUrl?: string | null;
        earnedDate?: string | null;
      }>;
      journeys: Array<PatientJourney>;
      firstTherapySessionDate?: string | null;
      lifetimeUsageHours?: number | null;
      processHealthDataOptIn?: boolean | null;
      streaksEnabled?: boolean | null;
      streaksPushEnabled?: boolean | null;
      announcementsPushEnabled?: boolean | null;
      accountCreationTime?: string | null;
      equipmentReplacementPushEnabled?: boolean | null;
      equipmentResupplyPushEnabled?: boolean | null;
      equipmentManagementEnabled?: boolean | null;
      heightInCentimeters?: number | null;
      heightInCm?: number | null;
      weightInKilograms?: number | null;
      weightInKg?: number | null;
      goalTrackingCompleted?: boolean | null;
    };
    fgDevices: Array<{
      __typename: 'FgDevice';
      serialNumber: string;
      deviceType?: FgDeviceType | null;
      deviceSeries?: FgSeries | null;
      deviceFamily?: FgFamily | null;
      lastSleepDataReportTime?: string | null;
      localizedName: string;
      imagePath: string;
      imageUrl: string;
      fgDeviceManufacturerName: string;
      fgDevicePatientId: string;
      deviceSubtype: FgDeviceSubtype;
      manufacturer: FgDeviceManufacturer;
      ptcsInfo?: {
        __typename: 'PTCSInfo';
        isEnabled: boolean;
        firstEnabledDate?: string | null;
      } | null;
    }>;
    masks: Array<{
      __typename: 'Mask';
      maskManufacturerName: string;
      maskCode: string;
      maskType: string;
      localizedName: string;
      imagePath: string;
      imageUrl: string;
      maskPatientId: string;
      cushionType: CushionType;
      manufacturer: MaskManufacturer;
      cushionMaterial: CushionMaterial;
    }>;
    coachingHistory?: {
      __typename: 'PaginatedCoachingHistory';
      items: Array<{
        __typename: 'CoachingHistory';
        date: string;
        sleepLibraryId: string;
        smartCoachingId?: string | null;
      }>;
      lastEvaluatedKey?: string | null;
    } | null;
    sleepLibrary: Array<{
      __typename: 'SleepLibrary';
      title: string;
      thumbnail: string;
      description: string;
      videoOrHtmlUrl: string;
      contentId: string;
      language: string;
      sleepLibraryId: string;
      section: string;
      type: string;
      sleepLibraryPatientId: string;
      analyticsScreenName: string;
      videoId?: string | null;
    }>;
    equipmentCareCoachingContent: Array<{
      __typename: 'SleepLibrary';
      title: string;
      thumbnail: string;
      description: string;
      videoOrHtmlUrl: string;
      contentId: string;
      language: string;
      sleepLibraryId: string;
      section: string;
      type: string;
      sleepLibraryPatientId: string;
      analyticsScreenName: string;
      videoId?: string | null;
    }>;
    sleepRecords?: {
      __typename: 'PaginatedSleepRecords';
      items: Array<{
        __typename: 'SleepRecord';
        startDate: string;
        totalUsage: number;
        sleepScore: number;
        usageScore: number;
        ahiScore: number;
        maskScore: number;
        leakScore: number;
        ahi?: number | null;
        maskPairCount: number;
        leakPercentile?: number | null;
        sleepRecordPatientId?: string | null;
      }>;
      lastEvaluatedKey?: string | null;
    } | null;
    notifications: Array<{
      __typename: 'Notification';
      id: string;
      action: NotificationAction;
      title: string;
      description?: string | null;
      positiveButtonTitle: string;
      negativeButtonTitle: string;
      url?: string | null;
      imageUrl?: string | null;
      negativeActionId?: string | null;
      negativeActionContent?: {
        __typename: 'NotificationPostActionContent';
        title?: string | null;
        description: string;
        positiveButtonTitle: string;
        negativeButtonTitle?: string | null;
      } | null;
      achievement?: {
        __typename: 'Achievement';
        id: string;
        name: string;
        description?: string | null;
        imageUrl?: string | null;
        earnedDate?: string | null;
      } | null;
    }>;
    dashboard: {
      __typename: 'Dashboard';
      sectionsV1: Array<{
        __typename: 'SectionV1';
        sectionType: SectionType;
      } | null>;
      sectionsV2: Array<{
        __typename: 'SectionV2';
        sectionType: SectionTypeV2;
      } | null>;
      sectionsV3: Array<{
        __typename: 'SectionV3';
        sectionType: SectionTypeV2;
      }>;
      sectionsV4: Array<{
        __typename: 'SectionV4';
        sectionType: SectionTypeV2;
      }>;
    };
    healthTrends: {
      __typename: 'HealthTrends';
      usage: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      };
      stepCount?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      weightKilograms?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      activeCaloriesBurned?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      bloodOxygenPercent?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      bodyMassIndex?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      heartRateVariabilityMilliseconds?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      restingHeartRate?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      timeInBedMinutes?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      totalTimeAsleepMinutes?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      exerciseMinutes?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
      maskSeal: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      };
      ahi: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      };
      maskOnOffCount: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      };
      sleepScore: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      };
      restorativeSleep?: {
        __typename: 'HealthTrendItem';
        previousAverage?: number | null;
        currentAverage?: number | null;
        trend?: number | null;
      } | null;
    };
    achievements: Array<{
      __typename: 'Achievement';
      id: string;
      name: string;
      description?: string | null;
      imageUrl?: string | null;
      earnedDate?: string | null;
    }>;
    goalTrackingDates?: {
      __typename: 'GoalTrackingDates';
      goalPeriodStartDate: string;
      goalPeriodEndDate: string;
    } | null;
    sleepTests: Array<{
      __typename: 'SleepTest';
      id: string;
      isActive: boolean;
      minRecordingTimeInSeconds?: number | null;
    }>;
    cciTherapyResponse?: {
      __typename: 'CCITherapyResponse';
      cciSurveys: Array<{
        __typename: 'CCISurvey';
        dateTime?: string | null;
      }>;
    } | null;
    sleepSummary: {
      __typename: 'SleepSummary';
      date: string;
      totalTimeAsleepMinutes?: number | null;
      totalTimeInBedMinutes?: number | null;
      totalUsageHours?: number | null;
      sleepSessions?: Array<{
        __typename: 'SleepSession';
        startTime: string;
        endTime: string;
        timeAsleepSeconds: number;
        durationSeconds: number;
      }> | null;
    };
    consents: Array<{
      __typename: 'Consent';
      consentType: ConsentType;
      consentStatus: ConsentStatus;
      consentCreationTime?: string | null;
      consentExpirationTime?: string | null;
      consentUrl?: string | null;
    }>;
    narrativeScreens: Array<{
      __typename: 'NarrativeScreen';
      analyticsId: string;
      backgroundImage: {
        __typename: 'NarrativeBackgroundImage';
        url: string;
        anchorPoint: NarrativeAnchorPoint;
      };
      layout: NarrativeLayout;
      content: {
        __typename: 'NarrativeScreenContent';
        title: string;
        subtitle: string;
        callout?: string | null;
      };
      showPagingIndicator: boolean;
    }>;
    ptcsInfo?: {
      __typename: 'PTCSInfo';
      isEnabled: boolean;
      firstEnabledDate?: string | null;
      recommendation: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      };
      revertSettings?: {
        __typename: 'DeviceSettings';
        autoSetComfort?: string | null;
        rampEnable?: string | null;
        rampTime?: number | null;
        eprEnable?: string | null;
        eprType?: string | null;
        eprPressure?: number | null;
      } | null;
    } | null;
    streakDetails?: {
      __typename: 'StreakDetails';
      currentStreakLength: number;
      currentStreakStartDate: string;
      currentStreakEndDate: string;
      isFromPreviousMonth: boolean;
      longestStreakLength: number;
      freezeDaysRemaining: number;
      freezeDaysMax: number;
      streakUnqualifiedDays: Array<{
        __typename: 'StreakUnqualifiedDay';
        date: string;
        type: StreakUnqualifiedDayType;
      }>;
      lastWeekQualifyingDays: number;
      thisWeekQualifyingDays: number;
      isMilestoneDay?: boolean | null;
    } | null;
    resupplyInfo?: {
      __typename: 'ResupplyInfo';
      dueDate?: string | null;
      totalDays: number;
      hmeInfo?: {
        __typename: 'HmeInfo';
        id: string;
        name: string;
        phoneNumber?: string | null;
        email?: string | null;
        websiteUrl?: string | null;
        imageUrl?: string | null;
      } | null;
    } | null;
    dailyTherapyData: Array<{
      __typename: 'DailyTherapyData';
      date: string;
      ahi?: number | null;
      totalUsageHours?: number | null;
      totalSecondsInApnea?: number | null;
      respiratoryEvents?: Array<{
        __typename: 'RespiratoryEvent';
        startDate?: string | null;
        endDate: string;
        durationSeconds?: number | null;
        eventType: RespiratoryEventType;
      }> | null;
      therapyStatusEvents?: Array<{
        __typename: 'TherapyStatusEvent';
        date: string;
        eventType: TherapyStatusEventType;
      }> | null;
    }>;
    insurance?: {
      __typename: 'InsuranceInfo';
      name: string;
      planName: string;
      policyGroupId: string;
      policyHolderFirstName: string;
      policyHolderLastName: string;
    } | null;
    provider?: {
      __typename: 'ProviderInfo';
      name?: string | null;
      phone?: string | null;
      contactInfo?: string | null;
      addressForReturns?: string | null;
      customerServiceEmail?: string | null;
      website?: string | null;
    } | null;
    rapidOrder?: {
      __typename: 'RapidOrder';
      rapidOrderKey?: string | null;
      patientKey?: string | null;
      patientFirstName?: string | null;
      patientLastName?: string | null;
      patientEmailAddress?: string | null;
      patientBillingAddress?: {
        __typename: 'Address';
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        postalCode?: string | null;
      } | null;
      items?: Array<{
        __typename: 'RapidOrderItem';
        itemKey?: string | null;
        itemDescription?: string | null;
        qty?: number | null;
        eligibilityDrivingHcpcForItem?: string | null;
      } | null> | null;
      productLineQuestions?: Array<{
        __typename: 'ProductLineQuestion';
        productLineQuestionKey?: string | null;
        productLineQuestionDataType?: string | null;
        productLineQuestionName?: string | null;
        productLineQuestionText?: string | null;
        sortOrder?: number | null;
        isRequiredBeforeBooking?: boolean | null;
        isRequiredEvenAfterBooking?: boolean | null;
        isRequiredForMedicareOnly?: boolean | null;
        mustBeYesGroupName?: string | null;
        mustBeNoGroupName?: string | null;
        answerChoices?: Array<string | null> | null;
      } | null> | null;
    } | null;
    orderStatus?: {
      __typename: 'Order';
      key?: string | null;
      id?: number | null;
      currentStatus?: string | null;
      currentStatusSince?: string | null;
      workflowState?: string | null;
      workflowStateSince?: string | null;
      documentsNeeded?: Array<string | null> | null;
      preshipIssues?: Array<string | null> | null;
      createdDate?: string | null;
      bookedDate?: string | null;
      sentToShipperDate?: string | null;
      shippedDate?: string | null;
      pickedUpDate?: string | null;
      sentToBillingDate?: string | null;
      voidedDate?: string | null;
      writtenOffDate?: string | null;
      completedDate?: string | null;
      items?: Array<{
        __typename: 'StatusItem';
        itemKey?: string | null;
        itemName?: string | null;
        itemDescription?: string | null;
        qty?: number | null;
      } | null> | null;
      shippingAddress?: {
        __typename: 'Address';
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        postalCode?: string | null;
      } | null;
      shippingCarrier?: string | null;
      shippingTrackingNumber?: string | null;
      shippingTrackingNumberUrl?: string | null;
    } | null;
    orderHistory?: Array<{
      __typename: 'Order';
      key?: string | null;
      id?: number | null;
      currentStatus?: string | null;
      currentStatusSince?: string | null;
      workflowState?: string | null;
      workflowStateSince?: string | null;
      documentsNeeded?: Array<string | null> | null;
      preshipIssues?: Array<string | null> | null;
      createdDate?: string | null;
      bookedDate?: string | null;
      sentToShipperDate?: string | null;
      shippedDate?: string | null;
      pickedUpDate?: string | null;
      sentToBillingDate?: string | null;
      voidedDate?: string | null;
      writtenOffDate?: string | null;
      completedDate?: string | null;
      items?: Array<{
        __typename: 'StatusItem';
        itemKey?: string | null;
        itemName?: string | null;
        itemDescription?: string | null;
        qty?: number | null;
      } | null> | null;
      shippingAddress?: {
        __typename: 'Address';
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        postalCode?: string | null;
      } | null;
      shippingCarrier?: string | null;
      shippingTrackingNumber?: string | null;
      shippingTrackingNumberUrl?: string | null;
    } | null> | null;
    salesDialer?: {
      __typename: 'SalesDialer';
      patientKey: string;
      daysUntilPatientCanReorder: number;
      isEligibleForReorder: boolean;
    } | null;
    snapPatient?: {
      __typename: 'SnapPatient';
      patientKey?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      suffix?: string | null;
      emailAddress?: string | null;
      dateOfBirth?: string | null;
    } | null;
  } | null;
};

export type GetFeatureMetadataQuery = {
  getFeatureMetadata: {
    __typename: 'FeatureMetadata';
    dawn: {
      __typename: 'DawnFeature';
      enabled: boolean;
      myTherapyNavigatorEnabled: boolean;
      url?: string | null;
    };
    deviceControl: {
      __typename: 'DeviceControlFeature';
      enabled: boolean;
      version: number;
    };
    myAirDirect: {
      __typename: 'MyAirDirectFeature';
      enabled: boolean;
    };
    streaks: {
      __typename: 'StreaksFeature';
      enabled: boolean;
    };
    equipmentManagement: {
      __typename: 'EquipmentManagementFeature';
      enabled: boolean;
      scheduleConfig: Array<
        | {
            __typename: 'FgEquipmentReplacementScheduleConfigItem';
            recommendedRecurrenceDays: number;
            minRecurrenceDays: number;
            maxRecurrenceDays: number;
          }
        | {
            __typename: 'MaskEquipmentReplacementScheduleConfigItem';
            cushionType?: CushionType | null;
            cushionMaterial?: CushionMaterial | null;
            recommendedRecurrenceDays: number;
            minRecurrenceDays: number;
            maxRecurrenceDays: number;
          }
        | {
            __typename: 'ResupplyScheduleConfigItem';
            recommendedRecurrenceDays: number;
            minRecurrenceDays: number;
            maxRecurrenceDays: number;
          }
      >;
      marketType: EquipmentMarketType;
    };
    coaching: {
      __typename: 'CoachingFeature';
      smartCoachingEnabled: boolean;
    };
    support: {
      __typename: 'SupportFeature';
      showAdaLabel: boolean;
    };
    mask: {
      __typename: 'MaskFeature';
      showMaskMagneticEducationalMaterials: boolean;
    };
    achievements: {
      __typename: 'AchievementsFeature';
      enabled: boolean;
    };
    userInfo: {
      __typename: 'UserInfoFeature';
      papTherapyOnboardingQuestionsEnabled: boolean;
    };
    appWidget: {
      __typename: 'AppWidgetFeature';
      enabled: boolean;
    };
    watch: {
      __typename: 'WatchFeature';
      enabled: boolean;
    };
    sleepRecord: {
      __typename: 'SleepRecordFeature';
      scoreEnabled: boolean;
    };
    consent: {
      __typename: 'ConsentFeature';
      isRevokeConsentVisible: boolean;
      isUpdateConsentVisible: boolean;
      isFaqContentVisible: boolean;
    };
    dataExperience: {
      __typename: 'DataExperienceFeature';
      timelineEnabled: boolean;
    };
    sleepTest: {
      __typename: 'SleepTestFeature';
      enabled: boolean;
    };
  };
};

export type GetMaskQuestionsQueryVariables = {
  maskCode: string;
  locale: string;
};

export type GetMaskQuestionsQuery = {
  getMaskQuestions?: Array<{
    __typename: 'MaskQuestion';
    questionId: string;
    localizedQuestion: string;
    answers: Array<{
      __typename: 'MaskAnswer';
      answerId: string;
      localizedAnswer: string;
    }>;
  }> | null;
};
